export default __webpack_public_path__ + "static/cma-9f0c85d3ec78e33f40d7302ffe25a817.png";